<template lang="pug">
  .notification
    .notification__header
      .notification__title
        template(v-if="isAdmin")
          | Оплаченный период завершен
        template(v-else)
          | Ваш ConPlus заблокирован
      .notification__date {{ hours }}
    .notification__body
      p.notification__content
        template(v-if="isAdmin")
          | Оплаченный период ConPlus завершен.
          br
          | Пользователь:
          strong {{ payload.firmName }}
          br
          a(v-bind:href="'mailto:' + payload.firmEmail") {{ payload.firmEmail }}
        template(v-else)
          | Оплаченный период завершен.
          br
          | Оплатите тариф для возобновления работы.
          br
          router-link.notification__link(
            @click.native="emitClick"
            title="Выбрать тариф"
            :to="{name: 'payments'}"
          ) Выбрать тариф
</template>

<script>
import notification from '@/mixins/notification.mixin';

export default {
  name: 'PackageEnded',
  mixins: [notification]
};
</script>
